<ui-section title="Edit address format" [collapsable]="true">
	<div section-content>
		<div class="flex gap-8">
			<div class="flex flex-col w-1/2">
				<div class="flex-auto">
					<div>
						<app-dropdown
							label="Select an option"
							[itemGroups]="[{ items: addressFormatDropdownOptions }]"
							(onSelect)="setSelectedAddressFormat($event)"
							[value]="dropdownText()"
						></app-dropdown>
					</div>
				</div>

				<div class="mt-4 mb-2">Example</div>
				<app-container type="dark">
					<div class="h-32 mt-2 whitespace-pre">
						<div
							*ngFor="let line of address()"
							class="leading-normal"
							[innerHTML]="line"
						></div>
					</div>
				</app-container>
			</div>

			<div class="flex flex-col gap-4">
				<app-input-wrapper label="Province long form">
					<atomic-switch
						[ngModel]="addressFormattingSettings()?.provinceShortForm"
						(ngModelChange)="setProvinceLongForm($event)"
					/>
				</app-input-wrapper>

				<app-input-wrapper label="Add comma">
					<atomic-switch
						[ngModel]="addressFormattingSettings()?.hasComma"
						(ngModelChange)="setHasComma($event)"
					/>
				</app-input-wrapper>

				<app-input-wrapper label="Add space">
					<atomic-switch
						[ngModel]="addressFormattingSettings()?.addSpace"
						(ngModelChange)="setAddSpace($event)"
					/>
				</app-input-wrapper>
			</div>
		</div>
	</div>
</ui-section>
